export const FILTERS_MAP: Record<string, string> = {
  'boitataFacets.sellers': 'vendido-por',
};
export const FACETS_MAP: Record<string, string> = {
  'vendido-por': 'boitataFacets.sellers',
};
export const SOLD_BY_ATTRIBUTE = 'boitataFacets.sellers';
export const PAGE_FILTERS = ['page'];
export const SORT_BY_FILTERS = ['melhor-preco', 'menor-preco', 'order'];
export const OFFER_FILTERS = [
  'ofertas',
  'novidades',
  'exclusivo-leroy-merlin',
  'marca-propria',
];
